import { NgbCalendar, NgbDate, NgbDateParserFormatter, NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { DatatableComponent, SortDirection } from '@swimlane/ngx-datatable';
import { OrderHttpService } from 'src/app/http/order-http.service';
import { EventsService } from 'src/app/services/events.service';
import { AlertComponent } from 'src/app/shared/alert/alert.component';
import { ViewOrderModalComponent } from 'src/app/shared/modals/view-order-modal/view-order-modal.component';
import { ConfirmModalComponent } from 'src/app/shared/modals/confirm-modal/confirm-modal.component';
import { interval, Subscription } from 'rxjs';
import { AccountService } from 'src/app/services/account.service';
import { Howl } from 'howler';

@UntilDestroy()
@Component({
    selector: 'app-order-list',
    templateUrl: './order-list.component.html',
    styles: [],
})
export class OrderListComponent implements OnInit, OnDestroy {
    constructor(
        private activatedRoute: ActivatedRoute,
        private orderHttpService: OrderHttpService,
        private router: Router,
        private eventsService: EventsService,
        private modalService: NgbModal,
        private calendar: NgbCalendar,
        private ngbDateParserFormatter: NgbDateParserFormatter,
        public accountService: AccountService
    ) {}

    items: any[] = [];

    tempItems: any[] = [];

    @ViewChild('table') table: DatatableComponent;

    @ViewChild(AlertComponent) alert: AlertComponent;

    dateMode: string = 'today';

    model: NgbDateStruct;

    subscription: Subscription;

    todayDate: NgbDateStruct;

    currentHowl: any = null;

    ngOnInit(): void {
        this.routeData();
        this.eventsSub();
        this.initDatePicker();
        this.getOrdersInterval();
    }

    getOrdersInterval() {
        this.subscription = interval(60000).subscribe(() => {
            const modelFormatted = this.ngbDateParserFormatter.format(this.model);

            const todayFormatted = this.ngbDateParserFormatter.format(this.todayDate);

            if (modelFormatted === todayFormatted) {
                this.getOrderByDate(null, true);
            }

            if (this.checkIfAnyPlacedOrders()) {
                this.mp3Notification();
            } else {
                if (this.currentHowl) {
                    this.currentHowl.stop();
                }
            }
        });
    }

    initDatePicker() {
        this.model = this.calendar.getToday();
        this.todayDate = this.calendar.getToday();
    }

    eventsSub() {
        this.eventsService.trigger.pipe(untilDestroyed(this)).subscribe((data) => {
            if (data.name === 'newOrder') {
                this.getOrderbyId(data.value);
            }
        });
    }

    routeData() {
        this.activatedRoute.data.subscribe((data) => {
            this.items = data.data;
            this.tempItems = data.data;
        });
    }

    filterOrderByDate() {
        this.getOrderByDate(this.dateFormatted);
        this.dateMode = null;
    }

    getOrderByDate(date: any, checkNew?: boolean) {
        this.orderHttpService.getOrdersByDate(date).subscribe((data) => {
            if (checkNew) {
                this.checkNewOrders(this.items, data);
            }
            this.items = data;
            this.tempItems = data;
        });
    }

    checkNewOrders(currentOrders: any[], newOrders: any[]) {
        newOrders.forEach((element: any) => {
            const check = currentOrders.find((c) => c.orderMasterId === element.orderMasterId);
            if (!check) {
                this.mp3Notification();
                return false;
            }
        });
    }

    checkIfAnyPlacedOrders() {
        return this.items.some((c) => c.status === 'Placed');
    }

    getOrderbyId(orderId: any) {
        this.orderHttpService.getOrderbyId(orderId).subscribe((data) => {
            this.addToItems(data);
            this.table.onColumnSort({ sorts: [{ prop: 'orderMasterId', dir: 'desc' }] });
            this.mp3Notification();
        });
    }

    addToItems(item: any) {
        const order = this.items.find((c) => c.orderMasterId === item.orderMasterId);
        if (!order) {
            this.items.unshift(item);
            this.items = [...this.items];
            this.tempItems.push(item);
        }
    }

    mp3Notification() {
        this.currentHowl = new Howl({
            src: ['/assets/mp3/cuisine-harp_default_v2.mp3'],
            loop: true,
        });
        this.currentHowl.play();
    }

    tableFiltring(event: any) {
        const val = event.target.value.toLowerCase();
        const temp = this.tempItems.filter(function (d) {
            return d.orderMasterId.toString().toLowerCase().indexOf(val) !== -1 || !val;
        });
        this.items = temp;
        this.table.offset = 0;
    }

    openOrder(item: any) {
        this.orderHttpService.getOrderDetailsbyId(item.orderMasterId).subscribe((data) => {
            let orderModal = this.modalService.open(ViewOrderModalComponent, { size: 'xl', windowClass: 'order-modal' });
            orderModal.componentInstance.order = data;
        });
    }

    confirmAccept(item: any) {
        let confirm = this.modalService.open(ConfirmModalComponent);
        confirm.componentInstance.headerLabel = `Accept Order`;
        confirm.componentInstance.messageLabel = `Are you sure you want to Accept #${item.orderMasterId} Order?`;
        confirm.result.then(
            (result) => {
                if (result === 'ok') {
                    this.orderAccepted(item);
                }
            },
            () => {}
        );
    }

    confirmInDelivery(item: any) {
        let confirm = this.modalService.open(ConfirmModalComponent);
        confirm.componentInstance.headerLabel = `In Delivery Order`;
        confirm.componentInstance.messageLabel = `Are you sure you want to In Delivery #${item.orderMasterId} Order?`;
        confirm.result.then(
            (result) => {
                if (result === 'ok') {
                    this.orderInDelivery(item);
                }
            },
            () => {}
        );
    }

    confirmDelivered(item: any) {
        let confirm = this.modalService.open(ConfirmModalComponent);
        confirm.componentInstance.headerLabel = `Delivered Order`;
        confirm.componentInstance.messageLabel = `Are you sure you want to Delivered #${item.orderMasterId} Order?`;
        confirm.result.then(
            (result) => {
                if (result === 'ok') {
                    this.orderDelivered(item);
                }
            },
            () => {}
        );
    }

    confirmCancel(item: any) {
        let confirm = this.modalService.open(ConfirmModalComponent);
        confirm.componentInstance.headerLabel = `Cancel Order`;
        confirm.componentInstance.messageLabel = `Are you sure you want to Cancel #${item.orderMasterId} Order?`;
        confirm.result.then(
            (result) => {
                if (result === 'ok') {
                    this.orderCancel(item);
                }
            },
            () => {}
        );
    }

    orderAccepted(item: any) {
        this.orderHttpService.acceptOrderById(item.orderMasterId).subscribe((data) => {
            let order = this.items.find((c) => c.orderMasterId === data);
            let tempOrder = this.tempItems.find((c) => c.orderMasterId === data);
            order.status = 'Accepted';
            tempOrder.status = 'Accepted';
            this.alert.addAlert({ type: 'success', message: `Order #${item.orderMasterId} Successfully Marked as Accepted` });

            setTimeout(() => {
                if (!this.checkIfAnyPlacedOrders()) {
                    if (this.currentHowl) {
                        this.currentHowl.stop();
                    }
                }
            });
        });
    }

    orderInDelivery(item: any) {
        this.orderHttpService.inDeliveryOrderById(item.orderMasterId).subscribe((data) => {
            let order = this.items.find((c) => c.orderMasterId === data);
            let tempOrder = this.tempItems.find((c) => c.orderMasterId === data);
            order.status = 'In Delivery';
            tempOrder.status = 'In Delivery';
            this.alert.addAlert({ type: 'success', message: `Order #${item.orderMasterId} Successfully Marked as In Delivery` });
        });
    }

    orderDelivered(item: any) {
        this.orderHttpService.deliveredOrderById(item.orderMasterId).subscribe((data) => {
            let order = this.items.find((c) => c.orderMasterId === data);
            let tempOrder = this.tempItems.find((c) => c.orderMasterId === data);
            order.status = 'Delivered';
            tempOrder.status = 'Delivered';
            this.alert.addAlert({ type: 'success', message: `Order #${item.orderMasterId} Successfully Marked as Delivered` });
        });
    }

    orderCancel(item: any) {
        this.orderHttpService.cancelOrderById(item.orderMasterId).subscribe((data) => {
            let order = this.items.find((c) => c.orderMasterId === data);
            let tempOrder = this.tempItems.find((c) => c.orderMasterId === data);
            order.status = 'Canceled';
            tempOrder.status = 'Canceled';
            this.alert.addAlert({ type: 'success', message: `Order #${item.orderMasterId} Successfully Marked as Canceled` });
        });
    }

    toggleDateMode(value: any) {
        this.dateMode = value;

        switch (value) {
            case 'today':
                const today = this.ngbDateParserFormatter.format(this.calendar.getToday());
                this.getOrderByDate(today);
                this.model = this.calendar.getToday();
                break;
            case 'yesterday':
                const yesterday = this.ngbDateParserFormatter.format(this.calendar.getPrev(this.calendar.getToday()));
                this.getOrderByDate(yesterday);
                this.model = this.calendar.getPrev(this.calendar.getToday());
                break;
        }
    }

    get dateFormatted() {
        return this.ngbDateParserFormatter.format(this.model);
    }

    ngOnDestroy(): void {
        this.eventsService.trigger.next({ name: null, value: null });
        this.subscription.unsubscribe();
    }
}
